import React, { MouseEventHandler } from 'react'
import classname from 'classnames'
import { AsyncLoader, CircularLoader, Icon } from '@contentstack/venus-components'
import StopIcon from "../assets/StopButton"
import "./LoadingScreen.css"
import { LoaderType } from '../types'
import StopGenerationButton from '../StopGenerationButton/StopGenerationButton'

interface LoadingScreen {
  message?: string,
  showMessage?: boolean,
  handleStopGeneration?: MouseEventHandler<HTMLDivElement>,
  type?: LoaderType
}

const LoadingScreen = ({
  message = 'Initializing your app...almost there!',
  showMessage = true,
  handleStopGeneration,
  type = "asyncLoader"
}: LoadingScreen) => {

  const containerClassName = classname('loading-container', {
    'short-container': showMessage && type === "asyncLoader",
    'circular-loader-container': showMessage && type === "circular"
  })

  return (
    <div className={containerClassName}>
      {
        type === "asyncLoader" ? (
          <AsyncLoader color='#6c5ce7' />
        ) : (
          <CircularLoader
            loadingColor='#6c5ce7'
            size='large'
          />
        )
      }
      {showMessage && <div className='loading-description'>{message}</div>}
      {
        handleStopGeneration &&
        <StopGenerationButton
          handleStopGeneration={handleStopGeneration}
          icon={type === "asyncLoader" ? "square" : "cancel"}
        />
      }
    </div>
  )
}

export default LoadingScreen